module.exports = __webpack_public_path__ + "static/media/step1.12f304f8.png";